import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgIf, NgFor } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-asset-selection-dialog',
  standalone: true,
  imports: [NgIf, NgFor, MatRadioModule, MatButtonModule, FormsModule],
  templateUrl: './asset-selection-dialog.component.html',
  styleUrl: './asset-selection-dialog.component.scss',
})
export class AssetSelectionDialogComponent {
  assets = this.data.assets || [];
  selectedAssetId: number | null = null;
  urlDomain: any;

  uploadedFile: File;
  filePreviewUrl: string;

  constructor(
    public dialogRef: MatDialogRef<AssetSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.urlDomain = localStorage.getItem('urlDomain');
    this.uploadedFile = data.uploadedFile?.name;
    console.log(this.uploadedFile, 'this.uploadedFile');
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onConfirm() {
    const selected = this.assets.find(
      (asset: any) => asset.id === this.selectedAssetId
    );
    this.dialogRef.close(selected || null);
  }

  selectOnlyOne(assetId: number) {
    this.selectedAssetId = assetId;
  }
}
